import { CssBaseline, ThemeProvider } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import theme from "../../../assets/theme";
import { setLayout, useMaterialUIController } from "../../../Context";
import { MDBox } from "../Components/MDBox";



interface IPageLayoutProps {
  background?: "white" | "light" | "default";
  children: React.ReactNode;
}

export const PageLayout: React.FC<IPageLayoutProps> = ({
  background,
  children
}: IPageLayoutProps) => {
  const [, dispatch] = useMaterialUIController() as any;
  //const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, []);
  //}, [pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MDBox theme={theme}
        width="100vw"
        height="100%"
        minHeight="100vh"
        bgColor={background}
        sx={{ overflowX: "hidden", backgroundImage: "url(https://app.bee123.co.za/Content/images/Landing-Background.jpg)" }}
      >
        {children}
      </MDBox>
    </ThemeProvider>
  );
}

// Setting default values for the props for PageLayout
PageLayout.defaultProps = {
  background: "default",
};
